import URIS from 'constants/uris';
import http from 'services/http';

export const fetchUploadPolicy = () =>
  http.post(`${URIS.CATALOG_IMAGES_TOKEN}`).then(({ data }) => data);
